// extracted by mini-css-extract-plugin
module.exports = {"story-texts":"composite-story-element-display_story-texts__2jW5r","gallery-element-image":"composite-story-element-display_gallery-element-image__2ML5C"};